"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Connection = void 0;
var Connection = (function () {
    function Connection(window) {
        this.window = window;
    }
    Connection.prototype.isOnline = function () {
        return this.window.navigator.onLine;
    };
    return Connection;
}());
exports.Connection = Connection;
